import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
const volumes = [{
  emoji: '📘',
  num: 'VOLUMEN 1',
  title: 'El Sistema Nervioso al Descubierto',
  desc: 'Por qué tu cerebro entra en pánico. Neurociencia, tipos de ansiedad y tu perfil personal de ansiedad.'
}, {
  emoji: '📗',
  num: 'VOLUMEN 2',
  title: 'El Sistema de Intervención Inmediata',
  desc: 'Protocolos de 30 a 90 segundos para frenar el ataque donde estés, sin que nadie lo note.'
}, {
  emoji: '📙',
  num: 'VOLUMEN 3',
  title: 'El Sistema de Reprogramación Mental',
  desc: 'TCC, ACT, EMDR y neuroplasticidad para cambiar el patrón de ansiedad de raíz.'
}, {
  emoji: '📕',
  num: 'VOLUMEN 4',
  title: 'El Sistema Corporal',
  desc: 'Nutrición, sueño, biohacking nervioso y movimiento para bajar la ansiedad de base.'
}, {
  emoji: '📓',
  num: 'VOLUMEN 5',
  title: 'El Sistema de Entorno',
  desc: 'Relaciones, trabajo y vida social sin que el mundo exterior dispare tu ansiedad.'
}, {
  emoji: '📒',
  num: 'VOLUMEN 6',
  title: 'El Sistema de Vida',
  desc: 'Tu plan maestro de mantenimiento para vivir sin ansiedad de por vida.'
}];
export function ProductSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-4 px-4 bg-primary" ref={ref} data-id="element-142">
      <div className="max-w-6xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-center mb-3" data-id="element-144">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-1" data-id="element-145">
            ¿Qué incluye el pack completo?
          </h2>
          <p className="text-accent-teal text-sm sm:text-base" data-id="element-146">
            6 Volúmenes · 360 páginas · Todo en PDF · Acceso inmediato y de por
            vida
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-147">
          {volumes.map((vol, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-card border-l-3 border-accent-gold rounded-md py-2.5 px-3 hover:-translate-y-1 hover:shadow-[0_0_15px_rgba(212,175,55,0.2)] transition-all duration-300 flex items-center" data-id="element-148">
              <div className="text-lg mr-2 shrink-0" data-id="element-149">{vol.emoji}</div>
              <div data-id="element-150">
                <span className="text-accent-gold text-[10px] font-bold tracking-wider block" data-id="element-151">
                  {vol.num}
                </span>
                <h3 className="text-white font-bold text-sm leading-tight" data-id="element-152">
                  {vol.title}
                </h3>
                <p className="text-text-secondary text-xs leading-snug" data-id="element-153">
                  {vol.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}